import { graphql } from "../gql";

export const ProgressCheckPdfFragment = graphql(`
  fragment ProgressCheckPdf on ProgressCheckPdf {
    pdfUrl
    userGroup {
      slug
      id
      name
    }
    userGroupId
    level
  }
`);
